<template>
  <div>
    <div class="cb-content" :class="{'cb-content--full-width':isExpiryOrTag}">
      <template v-if="pmType == 'card'">
        <span
          class="cb-content__icon"
          aria-hidden="true"
          :class="{'icon-cc-visa' : selectedCardType == 'visa', 'icon-cc-amex': (selectedCardType == 'amex' || selectedCardType == 'american_express'), 'icon-cc-mastercard-new': selectedCardType == 'mastercard', 'icon-cc-discover': selectedCardType == 'discover', 'icon-cc-diners-club': selectedCardType == 'diners_club'}"
          :style="themeColor"
        ></span>
        <span v-if="!selectedCardType">{{st('credit_card')}}</span>
        <span class="cb-content__text">{{st('ending')}} {{last4}}</span>
      </template>
      <template v-if="pmType == 'paypal_express_checkout'">
        <i
          class="icon-paypal cb-content__icon cb-content__icon--sm"
          aria-hidden="true"
          :style="themeColor"
        ></i>
        <span class="cb-content__text">{{paypal_email}}</span>
      </template>
      <template v-if="pmType == 'amazon_payments'">
        <template v-if="isPersistent">
          <i class="icon-amazon-pay cb-content__icon cb-content__icon--sm" aria-hidden="true"></i>
          <span class="cb-content__text">{{amazon_email}}</span>
        </template>
        <template v-else>
          <i class="icon-amazon-pay cb-content__icon cb-content__icon--sm" aria-hidden="true"></i>
          <span class="cb-content__text">{{cmt('pm.amazon_payments')}}</span>
        </template>
      </template>
      <template v-if="pmType == 'apple_pay'">
        <template v-if="isPersistent">
          <i
            class="icon-apple-pay-textual-border cb-content__icon cb-content__icon"
            aria-hidden="true"
          ></i>
          <span class="cb-content__text">{{cmt('pm.apple_pay')}}</span>
        </template>
        <template v-else>
          <i
            class="icon-apple-pay-textual cb-content__icon cb-content__icon--xl"
            aria-hidden="true"
          ></i>
        </template>
      </template>
      <template v-if="pmType == 'direct_debit'">
        <template v-if="isPersistent">
          <template v-if="bankAccountLast4">
            <i
              class="cb-content__icon"
              style="font-size:16px;"
              :class="{'icon-bank' : isACH, 'icon-direct-debit' : !isACH}"
              aria-hidden="true"
            ></i>
            <span class="cb-content__text">{{st('ending')}} {{bankAccountLast4}}</span>
          </template>
          <template v-else>
            <div
              class="cb-content cb-content--b-sm"
              :key="index"
              v-for="(details, index) in bankAccountOutputFields()"
            >
              <div class="cb-content__left" v-bind:key="index">{{details[0]}}</div>
              <div class="cb-content__right cb-content__bold" v-bind:key="index">{{details[1]}}</div>
            </div>
          </template>
          <span
            class="cb-content__flag"
            v-if="hasPendingVerification"
          >{{cmt('direct_debit.pending_verification')}}</span>
        </template>
        <template v-else>
          <i
            :class="{'icon-bank cb-content__icon cb-content__icon--sm': isACH, 'icon-direct-debit cb-content__icon cb-content__icon--st':!isACH}"
            aria-hidden="true"
          ></i>
          <span class="cb-content__middle">{{isACH ? st('pm.ach') : st('pm.direct_debit')}}</span>
          <div
            class="cb-content cb-content--b-sm"
            :key="index"
            v-for="(details, index) in bankAccountInputFields()"
          >
            <div class="cb-content__left" v-bind:key="index">{{details[0]}}</div>
            <div class="cb-content__right cb-content__bold" v-bind:key="index">{{details[1]}}</div>
          </div>
        </template>
      </template>
      <div class="cb-tf--right">
        <span
          class="cb-label"
          v-if="showPrimaryTag"
          :style="backgroundColor"
        >{{t('payment_method_tag.primary')}}</span>
        <span
          class="cb-label cb-label__secondary"
          v-if="showBackupTag"
        >{{t('payment_method_tag.backup')}}</span>
      </div>
      <div v-if="cardExpiry && this.t('card.expired') && t('card.expiring')" class="cb-note--margin">
      <template v-if="cardExpiry == 'expired'">
          <cb-notes :type="'error'" :message="t('card.expired',{card_expiry: this.cardExpiryDate})"></cb-notes>
      </template>
      <template v-else-if="cardExpiry == 'expiring'">
        <cb-notes :type="'warning'" :message="t('card.expiring', { card_expiry: this.cardExpiryDate})"></cb-notes>
      </template>
      <template v-else>
        <span>{{cardExpiry}}</span>
      </template>
    </div>
    <span v-else-if="cardExpiry" class="cb-content__flag">
        <span v-if="cardExpiry == 'expired'">{{st('card_expired')}}</span>
        <span v-else-if="cardExpiry == 'expiring'">{{st('card_expiring')}}</span>
        <span v-else>{{cardExpiry}}</span>
    </span>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
import PaymentMethodDisplayer from "@/utils/payment-method-displayer";
import cardFormatter from "@/utils/card-formatter";
import Notes from "@/components/collections/elements/Notes";
export default {
  props: ["persistentPaymentMethod", "transientPaymentMethod", "showRole"],
  components: {
    "cb-notes": Notes
  },
  computed: {
    isPersistent() {
      return this.persistentPaymentMethod ? true : false;
    },
    selectedCardType() {
      // Change this way of writing code
      return (
        (this.persistentPaymentMethod &&
          this.persistentPaymentMethod.card &&
          this.persistentPaymentMethod.card.brand) ||
        this.cardType
      );
    },
    pmType() {
      return (
        (this.persistentPaymentMethod && this.persistentPaymentMethod.type) ||
        (this.transientPaymentMethod && this.transientPaymentMethod.type)
      );
    },

    isACH() {
      let pm = this.pm_by_type(this.pmType);
      if (pm && pm.configuration) {
        return pm.configuration.scheme == "ACH";
      } else {
        // stripe ach not allowed in checkout, so you didn't get configuration
        return (
          this.isPersistent && this.persistentPaymentMethod.gateway == "stripe"
        );
      }
    },

    gatewayName() {
      return this.pm_by_type(this.pmType).gateway_name;
    },
    last4() {
      return (
        (this.persistentPaymentMethod &&
          this.persistentPaymentMethod.card &&
          this.persistentPaymentMethod.card.last4) ||
        this.transientPaymentMethodLast4
      );
    },
    bankAccountLast4() {
      return (
        this.persistentPaymentMethod &&
        this.persistentPaymentMethod.bank_account &&
        this.persistentPaymentMethod.bank_account.last4
      );
    },
    hasPendingVerification() {
      return (
        this.persistentPaymentMethod &&
        this.persistentPaymentMethod.status == "pending_verification"
      );
    },
    paypal_email() {
      return (
        (this.persistentPaymentMethod &&
          this.persistentPaymentMethod.paypal &&
          this.persistentPaymentMethod.paypal.email) ||
        (this.transientPaymentMethod &&
          this.transientPaymentMethod.meta &&
          this.transientPaymentMethod.meta.payer_email)
      );
    },
    amazon_email() {
      return (
        this.persistentPaymentMethod &&
        this.persistentPaymentMethod.amazon_payment &&
        this.persistentPaymentMethod.amazon_payment.email
      );
    },
    transientPaymentMethodLast4() {
      let tmp =
        this.transientPaymentMethod && this.transientPaymentMethod.tmp_token
          ? this.tmp_storage_get(this.transientPaymentMethod.tmp_token)
          : this.transientPaymentMethod;

      return (
        tmp &&
        tmp.number &&
        tmp.number.substring(tmp.number.length - 4, tmp.number.length)
      );
    },
    cardType() {
      let tmp =
        this.transientPaymentMethod && this.transientPaymentMethod.tmp_token
          ? this.tmp_storage_get(this.transientPaymentMethod.tmp_token)
          : this.transientPaymentMethod;
      return tmp && cardFormatter.cardType(tmp.number);
    },
    ...mapGetters(["tmp_storage_get", "pm_by_type", "primary_pm", "backup_pm"]),
    cardExpiry() {
      if (
        !(this.persistentPaymentMethod && this.persistentPaymentMethod.card)
      ) {
        return;
      }
      return this.persistentPaymentMethod.status != "valid"
        ? this.persistentPaymentMethod.status
        : false;
    },
    paymentMethod() {
      return this.persistentPaymentMethod || this.transientPaymentMethod;
    },
    pmId() {
      return this.paymentMethod && this.paymentMethod.id;
    },
    cardExpiryDate() {
      return (
        this.paymentMethod.type === "card" &&
        this.paymentMethod.card.expiry_month +
          "/" +
          this.paymentMethod.card.expiry_year
      );
    },
    isExpiryOrTag() {
      return this.cardExpiry || this.showPrimaryTag || this.showBackupTag;
    },
    showPrimaryTag() {
      return this.showRole && this.primary_pm && this.primary_pm.id == this.pmId;
    },
    showBackupTag() {
      return this.showRole && this.backup_pm && this.backup_pm.id == this.pmId;
    }
  },
  methods: {
    bankAccountOutputFields() {
      return PaymentMethodDisplayer.bankAccountOutputFields()
        .map(f => {
          if (f.displayer) {
            return [
              f.name,
              f.displayer(this.persistentPaymentMethod.bank_account[f.field])
            ];
          }
          return [f.name, this.persistentPaymentMethod.bank_account[f.field]];
        })
        .filter(
          f => !!f[1] && f[1] != "not_applicable" && f[1] != "Not_applicable"
        );
    },
    bankAccountInputFields() {
      return PaymentMethodDisplayer.bankAccountInputFields(this.isACH)
        .map(f => {
          if (f.displayer) {
            return [
              this.$store.getters.get_text(f.label_key),
              f.displayer(this.transientPaymentMethod[f.field])
            ];
          }
          return [
            this.$store.getters.get_text(f.label_key),
            this.transientPaymentMethod[f.field]
          ];
        })
        .filter(f => !!f[1]);
    }
  }
};
</script>



// WEBPACK FOOTER //
// PaymentMethodSummary.vue?795fd75e